import { normalizedUuidSchema } from '@repo/api-contracts';
import { parseSizeQuantities, type SizeQuantities } from '@/shared/config';

export interface PlainQuoteRequestParams {
  readonly productId: string;
  readonly colorOptionId: string;
  readonly quantity: number | null;
  readonly sizes: SizeQuantities;
}

/** ?qty= 쿼리 — 양의 정수일 때만 처음 수량으로 넘긴다(최소 주문 수량 확인은 폼이 한다). */
const parseQtyParam = (raw: string | null): number | null => {
  if (raw === null || !/^\d+$/.test(raw)) return null;
  const value = Number(raw);
  return Number.isSafeInteger(value) && value > 0 ? value : null;
};

/** 상품(경로)·색상(?color=)은 uuid(소문자로 정규화)여야 한다 — 하나라도 아니면 null. */
export const parsePlainQuoteRequestParams = (
  rawProductId: string,
  rawColorOptionId: string | null,
  rawQuantity: string | null,
  rawSizes: string | null = null,
): PlainQuoteRequestParams | null => {
  const productId = normalizedUuidSchema.safeParse(rawProductId);
  const colorOptionId = normalizedUuidSchema.safeParse(rawColorOptionId ?? '');
  if (!productId.success || !colorOptionId.success) return null;
  return {
    productId: productId.data,
    colorOptionId: colorOptionId.data,
    quantity: parseQtyParam(rawQuantity),
    sizes: parseSizeQuantities(rawSizes),
  };
};
